import styled from 'styled-components';

// Shared between buy-it-again-out-of-stock-card.tsx and buy-it-again-substitute-modal.tsx --
// mirrors the strain-type pill and potency text styling from src/components/product-card-v2
// (CardStrainType / CardPotency) so OOS/substitute cards match in-stock product cards.

export const StrainBadge = styled.span`
  background: #e3e7e9;
  border-radius: 12px;
  color: #2c3236;
  display: inline-block;
  font-family: ${({ theme }) => theme.customized.fonts.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 6px 8px;
`;

export const PotencyText = styled.span`
  color: #646d72;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
`;
